

import { ICategory, ICategoryResponse } from "../../../model/respone/san-pham/ICategory"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eCategoryActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ICategoryResponse[],
    LOAD_ERROR: "",
    
    SHOW_EDIT_MODAL: {} as undefined | ICategory,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ICategory,
    SAVE_SUCCESS: {} as ICategory,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eCategoryActionTypeIds = generateActionTypeIds(eCategoryActionTypeDefine, "CATEGORY")

export type ICategoryActions = IGenericActionType<typeof eCategoryActionTypeDefine, "CATEGORY">